var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasBanner)?_c('div',{staticClass:"single-banner-container",style:(`background-color:${_setup.backgroundColor}`)},[_c(_setup.SingleBannerItem,{attrs:{"banner-info":_setup.bannerInfo}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }